export const dateToTimeZone = (date: string | Date, timeZone: string) => {
  return new Date(new Date(date).toLocaleString('en-US', { timeZone }));
};
